import React, {useState} from "react";
import {FaCheck} from "react-icons/fa6";
import CardDetailPopover from "../card-detail-popover";

const CardMembersPopover = ({members, availableUsers, onUpdate, onRemove, openOnMount, onOpenOnMount, readOnly = false}) => {
    const [search, setSearch] = useState("");
    const [selectedMembers, setSelectedMembers] = useState(() => [...members]);
    const filteredUsers = availableUsers.filter(user => String(user.label ?? "").toLowerCase().includes(search.trim().toLowerCase()));
    const getMember = member => availableUsers.find(user => String(user.value) === String(member));
    const getMemberLabel = member => getMember(member)?.label ?? String(member);
    const getInitials = member => getMemberLabel(member).split(/\s+/).filter(Boolean).slice(0, 2).map(part => part.charAt(0)).join("").toUpperCase();

    const toggleMember = member => setSelectedMembers(current => {
        const nextMembers = current.some(value => String(value) === String(member))
            ? current.filter(value => String(value) !== String(member))
            : [...current, member];
        onUpdate({assignees: nextMembers}, "alterou os membros da tarefa");
        return nextMembers;
    });

    const handleOpenChange = open => {
        if (open) setSelectedMembers([...members]);
        else setSearch("");
    };

    return (
        <CardDetailPopover
            title="Membros da tarefa"
            panelTitle="Membros"
            onRemove={onRemove}
            onOpenChange={handleOpenChange}
            openOnSummaryClick
            openOnMount={openOnMount}
            onOpenOnMount={onOpenOnMount}
            readOnly={readOnly}
            summary={members.map(member => (
                <span key={member} title={getMemberLabel(member)} className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white ring-2 ring-white">
                    {getInitials(member)}
                </span>
            ))}
        >
            {() => (
                <div>
                    <label htmlFor="card-member-search" className="sr-only">Pesquisar membros</label>
                    <input id="card-member-search" type="search" value={search} onChange={({target}) => setSearch(target.value)} placeholder="Pesquisar membros" className="mb-3 h-9 w-full rounded-md border border-slate-300 px-3 text-sm text-slate-700 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100" />
                    <p className="mb-2 text-xs font-semibold text-slate-500">Membros disponíveis</p>
                    <div className="max-h-52 space-y-1 overflow-y-auto">
                        {filteredUsers.map(user => {
                            const isSelected = selectedMembers.some(member => String(member) === String(user.value));
                            return (
                                <button key={user.value} type="button" onClick={() => toggleMember(user.value)} className={`flex w-full items-center gap-2 rounded-md px-2 py-2 text-left text-sm transition-colors ${isSelected ? "bg-blue-50 text-blue-700" : "text-slate-700 hover:bg-slate-100"}`}>
                                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-blue-600 text-[11px] font-bold text-white">{getInitials(user.value)}</span>
                                    <span className="min-w-0 flex-1 truncate">{user.label}</span>
                                    {isSelected && <FaCheck className="shrink-0 text-blue-600" />}
                                </button>
                            );
                        })}
                        {filteredUsers.length === 0 && <p className="py-3 text-center text-sm text-slate-400">Nenhum membro encontrado.</p>}
                    </div>
                </div>
            )}
        </CardDetailPopover>
    );
};

export default CardMembersPopover;
